export default __webpack_public_path__ + "static/media/circle-dark.2eb10a63.svg";